import {
  getOGCustomer,
  getOGUpcomingOrders,
  sortOGOrders,
} from '../subscription-modal/ordergroove-api-helper'

export default () => ({
  initialized: false,
  init() {
    if (this.initialized) return
    this.initialized = true
    removeSellingPlanIdFromAddCartForm()
    removeAddToNextBoxFromAddCartForm()
    initializeOGAuth()
  }
})

function showModalOptions(option) {
  // show the correct modal options based on user subscription status
  const purchaseOptions = document.querySelector('.dsc-custom-ordergroove-ui-options')
  const inNextBoxMessage = document.querySelector('.in-next-box-message')
  const nextBoxRadioButton = document.querySelector('.add-one-time-to-next-box-radio-button')
  if (!inNextBoxMessage || !nextBoxRadioButton) return

  switch (option) {
    case 'not-a-subscriber':
      inNextBoxMessage.classList.add('hidden')
      nextBoxRadioButton.classList.add('hidden')
      break
    default:
      break
  }

  purchaseOptions.classList.remove('hidden')
}

function createHiddenInput({ id, name, value }) {
  const hiddenInput = document.createElement('input')
  hiddenInput.id = id
  hiddenInput.type = 'hidden'
  hiddenInput.name = name
  hiddenInput.value = value
  return hiddenInput
}

function addSellingPlanIdToAddCartForm(sellingPlanId) {
  if (document.querySelector('#selling-plan-id')) {
    updateSellingPlanIdOnAddCartForm(sellingPlanId)
    return
  }

  const addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]')
  const sellingPlanInput = createHiddenInput({
    id: 'selling-plan-id',
    name: 'selling_plan',
    value: sellingPlanId,
  })
  addToCartForm.append(sellingPlanInput)
}

function removeSellingPlanIdFromAddCartForm() {
  const sellingPlanInput = document.querySelector('#selling-plan-id')
  if (sellingPlanInput) {
    sellingPlanInput.remove()
  }
}

function updateSellingPlanIdOnAddCartForm(sellingPlanId) {
  const sellingPlanInput = document.querySelector('#selling-plan-id')
  if (sellingPlanInput) {
    sellingPlanInput.value = sellingPlanId
  }
}

function addAddToNextBoxToAddCartForm() {
  const addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]')
  if (document.querySelector('#add-to-next-box')) return;

  // add add-to-next-box hidden input
  const addToNextBoxInput = createHiddenInput({
    id: 'add-to-next-box',
    name: 'add_to_next_box',
    value: 'add_to_next_box',
  });
  addToCartForm.append(addToNextBoxInput)

  // add price to form
  const productInfo = document.querySelector('.legacy-dsc-custom-ordergroove-ui')
  const productVariantPrice = productInfo.getAttribute('data-product-variant-price')
  const productVariantPriceInput = createHiddenInput({
    id: 'product-variant-price',
    name: 'price',
    value: productVariantPrice,
  });
  addToCartForm.append(productVariantPriceInput)
}

function removeAddToNextBoxFromAddCartForm() {
  const addToNextBoxInput = document.querySelector('#add-to-next-box')
  const productVariantPriceInput = document.querySelector('#product-variant-price')
  if (addToNextBoxInput) {
    addToNextBoxInput.remove()
  }
  if (productVariantPriceInput) {
    productVariantPriceInput.remove()
  }
}

function setupListeners(isUserWithSubscription) {
  const subscriptionFrequency = document.querySelector('#subscription-frequency');
  const subscribeRadioButton = document.querySelector('#subscribe-radio-button');
  const shipNowRadioButton = document.querySelector('#ship-now-subscriber');
  const addToNextBoxRadioButton = document.querySelector('#add-one-time-to-next-box-subscriber');

  subscribeRadioButton.addEventListener('click', () => {
    setPurchaseOptionState({
      state: 'subscribe',
      sellingPlanId: subscriptionFrequency.value,
      isUserWithSubscription,
    });
  });

  subscriptionFrequency.addEventListener('change', (event) => {
    event.preventDefault();
    event.stopPropagation();

    setPurchaseOptionState({
      state: 'subscribe',
      checkRadioButton: true,
      sellingPlanId: event.target.value,
      isUserWithSubscription,
    });
  });

  shipNowRadioButton.addEventListener('click', () => {
    setPurchaseOptionState({
      state: 'ship-now',
      isUserWithSubscription,
    });
  });

  addToNextBoxRadioButton.addEventListener('click', () => {
    setPurchaseOptionState({
      state: 'add-to-next-box',
      isUserWithSubscription
    })
  });
}

function setPurchaseOptionState({ state, checkRadioButton, sellingPlanId, isUserWithSubscription }) {
  switch (state) {
    case 'subscribe':
      if (checkRadioButton) document.querySelector('#subscribe-radio-button').checked = true;

      if (isUserWithSubscription) {
        addAddToNextBoxToAddCartForm();
        changeAddToCartButtonText(window.dsc.addToNextBoxText);
      } else {
        removeAddToNextBoxFromAddCartForm();
        changeAddToCartButtonText(window.dsc.addToCartText);
      }
      
      addSellingPlanIdToAddCartForm(sellingPlanId);
      break;
    case 'add-to-next-box':
      if (checkRadioButton) document.querySelector('#add-one-time-to-next-box-subscriber').checked = true;
      removeSellingPlanIdFromAddCartForm();

      if (isUserWithSubscription) {
        changeAddToCartButtonText(window.dsc.addToNextBoxText);
      } else {
        changeAddToCartButtonText(window.dsc.addToCartText);
      }

      addAddToNextBoxToAddCartForm();
      break;
    case 'ship-now':
      if (checkRadioButton) document.querySelector('#ship-now-subscriber').checked = true;

      changeAddToCartButtonText(window.dsc.addToCartText);
      removeAddToNextBoxFromAddCartForm();
      removeSellingPlanIdFromAddCartForm();
      break;
    default:
      break;
  }
}

function getDefaultPurchaseOptionQueryParam() {
  const searchUrlParams = new URLSearchParams(window.location.search);
  const defaultPurchaseOptionQueryParam = searchUrlParams.get('defaultPurchaseOption');
  switch (defaultPurchaseOptionQueryParam) {
    case 'shipNow':
      return 'ship-now'
    case 'subscription':
      return 'subscribe'
    case 'add-to-next-box':
      return 'add-to-next-box'
    case 'add-one-time-to-next-box':
      return 'add-one-time-to-next-box'
    default:
      return ''
  }
}

function setDefaultPurchaseOption({ isProductSubscribeable, isUserWithSubscription }) {
  const defaultPurchaseOptionQueryParam = getDefaultPurchaseOptionQueryParam();
  const productInfo = document.querySelector('.legacy-dsc-custom-ordergroove-ui');

  let effectiveDefaultOption;

  if (isUserWithSubscription) {
    const subscriberOption = productInfo.getAttribute('data-default-purchase-option-subscribers');
    effectiveDefaultOption = subscriberOption || productInfo.getAttribute('data-default-purchase-option');
  } else {
    effectiveDefaultOption = productInfo.getAttribute('data-default-purchase-option');
  }

  const defaultOption = defaultPurchaseOptionQueryParam || effectiveDefaultOption;

  switch (defaultOption) {
    case 'add-to-next-box':
    case 'add-one-time-to-next-box':
      setPurchaseOptionState({
        state: 'add-to-next-box',
        checkRadioButton: true,
        isUserWithSubscription,
      });
      break;
    case 'subscribe':
      if (isProductSubscribeable) {
        const subscriptionFrequency = document.querySelector('#subscription-frequency');
        setPurchaseOptionState({
          state: 'subscribe',
          checkRadioButton: true,
          isUserWithSubscription,
          sellingPlanId: subscriptionFrequency.value,
        });
      } else {
        setPurchaseOptionState({
          state: 'add-to-next-box',
          isUserWithSubscription,
          checkRadioButton: true,
        });
      }
      break;
    case 'ship-now':
    case 'one-time':
      setPurchaseOptionState({
        state: 'ship-now',
        checkRadioButton: true,
        isUserWithSubscription,
      });
      break;
    default:
      break;
  }
}

function changeAddToCartButtonText(text) {
  const productForm = document.querySelector('product-form')
  if (productForm) {
    const addToCartButton = productForm.querySelector('.atc-text')
    addToCartButton.innerHTML = text
  }
}

async function initializeOGAuth() {
  await window.dsc?.ensureSubscriberHydrated?.()

  const ogCustomer = await getOGCustomer(window?.dsc?.customerId)
  const ogUpcomingOrders = await getOGUpcomingOrders(window?.dsc?.customerId)

  if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
    // sort orders by date
    sortOGOrders(ogUpcomingOrders.results)
  }

  const isUserWithSubscription = !!(ogCustomer && ogUpcomingOrders && ogUpcomingOrders.count > 0)
  const productInfo = document.querySelector('.legacy-dsc-custom-ordergroove-ui');
  const numberOfSellingPlans = productInfo.getAttribute('data-number-of-selling-plans');

  setupListeners(isUserWithSubscription);

  // figure out what UI we need to show
  if (isUserWithSubscription) {
    let isInNextBox = false
    if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
      isInNextBox = await window.dsc.toggleInNextBoxMessageTextPDP(ogUpcomingOrders.results[0]);
    }

    if (!isInNextBox) {
      if (numberOfSellingPlans === '0') {
        // hide subscribe button
        const subscriptionOptionContainer = document.querySelector('.subscribe-radio-button.option-container')
        subscriptionOptionContainer.classList.add('hidden');

        setDefaultPurchaseOption({
          isProductSubscribeable: false,
          isUserWithSubscription
        })
      } else {
        setDefaultPurchaseOption({
          isProductSubscribeable: true,
          isUserWithSubscription,
        });
      }
    }

    showModalOptions('subscriber')
  } else {
    if (numberOfSellingPlans === '0') {
      // hide all the options
      productInfo.remove()
      setDefaultPurchaseOption({
        isProductSubscribeable: false,
        isUserWithSubscription
      })
    } else {
      setDefaultPurchaseOption({
        isProductSubscribeable: true,
        isUserWithSubscription,
      });
    }

    showModalOptions('not-a-subscriber')
  }
}